import type { ReactNode } from "react";
import { cn } from "~/shared/lib/utils";
import { SECTION_V5 } from "./design-tokens";

export interface SectionShellProps {
    header: ReactNode;
    bulkBar?: ReactNode;
    toolbar: ReactNode;
    children: ReactNode;
    className?: string;
}

export function SectionShell({ header, bulkBar, toolbar, children, className }: SectionShellProps) {
    return (
        <div className={cn(SECTION_V5.pageShell, className)}>
            <div className={SECTION_V5.pageHeader}>{header}</div>
            {bulkBar ? <div className={SECTION_V5.bulkBar}>{bulkBar}</div> : null}
            <div className={SECTION_V5.toolbar}>{toolbar}</div>
            <div className={SECTION_V5.scrollContainer}>{children}</div>
        </div>
    );
}
